import { OverlayRef } from '@angular/cdk/overlay';
import { NgComponentOutlet } from '@angular/common';
import { Component, Input, signal, Type } from '@angular/core';

@Component({
  selector: 'tp-flyout-shell',
  imports: [NgComponentOutlet],
  templateUrl: './flyout-shell.component.html',
  styleUrl: './flyout-shell.component.scss',
})
export class FlyoutShellComponent {
  @Input({ required: true }) overlayRef!: OverlayRef;

  contentComponent = signal<Type<unknown> | null>(null);

  isOpen = signal(false);
  private readonly DURATION = 400;
  private readonly BUFFER = 10;

  constructor() {
    requestAnimationFrame(() => this.isOpen.set(true));
  }

  close() {
    this.isOpen.set(false);

    const backdrop = this.overlayRef.backdropElement;
    if (backdrop) backdrop.classList.add('flyout-backdrop-fading');

    setTimeout(() => {
      this.overlayRef.dispose();
    }, this.DURATION + this.BUFFER);
  }
}
